// @ts-nocheck

import { CheckOutlined } from '@ant-design/icons';
import React, { Component, Fragment } from 'react';
import Button from 'antd/lib/button';
import Space from 'antd/lib/space';
import styled from 'styled-components';
import isEqual from 'lodash/isEqual';



import { Card } from '../../../../components';
import { optionalEquipmentTypes } from '../../../../lib/enum';
import RemoveEquipmentButton from './../RemoveEquipmentButton';
import { formatDate } from '../../lib';
import { Spoiler, Icon } from '../../../../components/ui';
import Grid, { GridItem } from '../../../../components/layout/Grid';
import { InputNumber } from '../../../../components/inputs';
import { EquipmentActions } from '../elements';

const { Field } = Card;
const ButtonGroup = Space.Compact;

const SpoilerContent = styled.div`
  padding: 16px;
  border-bottom: 1px solid #c0ccd7;
`;













class OptionalEquipmentItem extends Component {
  state = {
    editMode: false,
    optionalEquipment: this.props.optionalEquipment
  };

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.optionalEquipment, this.props.optionalEquipment)) {
      this.setState({
        optionalEquipment: this.props.optionalEquipment
      });
    }
  }

  onApply = async () => {
    await this.props.onChange(this.state.optionalEquipment);
    this.setState({
      editMode: false
    });
  };

  changeOptionalEquipment = (fieldName, value) => {
    this.setState((prevState) => ({
      optionalEquipment: {
        ...prevState.optionalEquipment,
        [fieldName]: value
      }
    }));
  };

  onCancel = () =>
  this.setState({
    optionalEquipment: this.props.optionalEquipment,
    editMode: false
  });

  render() {
    const { onRemove, editable } = this.props;
    const { optionalEquipment = {}, editMode } = this.state;
    const {
      name,
      brandName,
      code,
      type,
      installDate,
      removeDate,
      inventoryNumber,
      actualFuelConsumption
    } = optionalEquipment;
    return (
      <Spoiler
        key={optionalEquipment.id}
        label={`${name} ${brandName}`}
        suffix={
        editable &&
        <EquipmentActions>
              <ButtonGroup>
                {editMode ?
            <Fragment>
                    <Button
                data-test="check"
                onClick={this.onApply}
                icon={<CheckOutlined />} />

                    <Button data-test="close" onClick={this.onCancel}>
                      <Icon type="x" />
                    </Button>
                  </Fragment> :

            <Button
              data-test="edit"
              onClick={() => this.setState({ editMode: true })}>

                    <Icon type="edit" />
                  </Button>
            }
              </ButtonGroup>
              <RemoveEquipmentButton
            onConfirm={(removeDate) =>
            onRemove({
              ...this.props.optionalEquipment,
              removeDate
            })
            } />

            </EquipmentActions>

        }>

        <SpoilerContent>
          <Grid gutter="16px">
            <GridItem>
              <Field label="Наименование">{name}</Field>
            </GridItem>
            <GridItem>
              <Field label="Тип">{optionalEquipmentTypes[type]}</Field>
            </GridItem>
            <GridItem>
              <Field label="Марка">{brandName}</Field>
            </GridItem>
            <GridItem>
              <Field label="Мнемокод">{code}</Field>
            </GridItem>
            {inventoryNumber &&
            <GridItem>
                <Field label="Инвентарный номер">{inventoryNumber}</Field>
              </GridItem>
            }
            <GridItem>
              <Field label="Фактический расход топлива на допол. обор., маш/час">
                {editMode ?
                <InputNumber
                  decimalSeparator=","
                  name="actualFuelConsumption"
                  value={actualFuelConsumption}
                  onChange={(value) =>
                  this.changeOptionalEquipment(
                    'actualFuelConsumption',
                    value
                  )
                  } /> :


                actualFuelConsumption
                }
              </Field>
            </GridItem>

            <GridItem>
              <Field label="Дата установки">{formatDate(installDate)}</Field>
            </GridItem>
            <GridItem>
              <Field label="Дата снятия">{formatDate(removeDate)}</Field>
            </GridItem>
          </Grid>
        </SpoilerContent>
      </Spoiler>);

  }
}

export default OptionalEquipmentItem;
